export default function Badge({ tone = "neutral", className = "", children, ...props }) {
  return (
    <span className={`ds-badge ds-badge--${tone}${className ? ` ${className}` : ""}`} {...props}>
      {children}
    </span>
  );
}
